export const blockType = {
  BLOCKHOLDER: 'BLOCK_HOLDER',
  NONBIDDER: 'NON_BIDDER',
  NONEXISTING: 'NonExistingPilot', /* ask BE to change value to NON_EXISTING */
  RESERVE: 'RESERVE'
};

export const CALENDAR_TYPE = {
  STANDARD: 'STANDARD_CALENDAR',
  STRIP: 'STRIP_CALENDAR'
};

export const eventActivityType = {
  DSP: 'DISP',
  GDO:'GDO',
  GDO6:'GDO+6',
  HOLIDAY:'Holiday',
  ITC: 'ITC',
  PAIRING: 'Pairing',
  PIT: 'PIT',
  RAP:'RAP',
  RAPH:'RAP-H',
  REASSIGN: 'REASSIGN',
  RELEASE:'RELEASE',
  RESERVE:'RSV',
  SDO:'SDO',
  SICK: 'Sick',
  SICK_INS: 'SICK_INS',
  TDO:'TDO',
  TDO6:'TDO+6',
  TRAINING: 'Training',
  VAC2448: 'VAC_24/48',
  VACATION: 'Vacation'
};
  
export const eventTrainingList = {
  ART: 'TR_ART',
  IOE: 'LINDOC',
  SCHOOL: 'SCHOOL',
  SIM: 'SIMLOCAL',
  SIMTRAVEL: 'SIMTRAVEL'
};

export const eventTransportationType = {
  LIMO: 'LIMO'
};

export const RELEASE_TYPE = {
  END: 'end',
  END_MARGIN_LEFT: 'endReleaseMarginLeft',
  END_WIDTH: 'endReleaseWidth',
  MIDDLE: 'middle',
  MIDDLE_MARGIN_LEFT: 'middleReleaseMarginLeft',
  MIDDLE_WIDTH: 'middleReleaseWidth',
  START: 'start',
  START_MARGIN_LEFT: 'startReleaseMarginLeft',
  START_WIDTH: 'startReleaseWidth'
};

export const STD_CAL_CELL_HEIGHT = {
  ONE: '14.8rem',
  TWO: '19rem',
  THREE: '22.4rem'
};

export const STD_CAL_TIMEZONE = {
  CENTRAL: 'Central Time (CT)',
  EASTERN: 'Eastern Time (ET)',
  PACIFIC: 'Pacific Time (PT)'
}

export const STRIP_CAL_EVENT_LEVEL_REM = {
  ONE: 3,
  TWO: 13.2,
  THREE: 18.6
};